import { call } from 'redux-saga/effects';

let initModule = null;
export function* initPurchaseMobileLine({ payload }) {
  if (!initModule) {
    initModule = yield call(() => import('./init'));
  }
  yield call(initModule.initPurchaseMobileLine, { payload });
}
let setInfoModule = null;
export function* setInfoMobileLine({ payload }) {
  if (!setInfoModule) {
    setInfoModule = yield call(() => import('./set-info'));
  }
  yield call(setInfoModule.setInfoMobileLine, { payload });
}
let checkOutModule = null;
export function* checkoutMobileLine({ payload }) {
  if (!checkOutModule) {
    checkOutModule = yield call(() => import('./checkout'));
  }
  yield call(checkOutModule.checkoutMobileLine, { payload });
}
let processOrderModule = null;
export function* processOrderMobileLine() {
  if (!processOrderModule) {
    processOrderModule = yield call(() => import('./process-order'));
  }
  yield call(processOrderModule.processOrderMobileLine, {});
}
let sendPurchaseOtpModule = null;
export function* sendPurchaseOtpMobileLine({ payload }) {
  if (!sendPurchaseOtpModule) {
    sendPurchaseOtpModule = yield call(() => import('./send-purchase-otp'));
  }
  yield call(sendPurchaseOtpModule.sendPurchaseOtpMobileLine, {
    payload,
  });
}
let validatePurchaseOtpModule = null;
export function* validatePurchaseOtpMobileLine({ payload }) {
  if (!validatePurchaseOtpModule) {
    validatePurchaseOtpModule = yield call(() =>
      import('./validate-purchase-otp')
    );
  }
  yield call(validatePurchaseOtpModule.validatePurchaseOtpMobileLine, {
    payload,
  });
}
let sendPortabilityOtpModule = null;
export function* sendPortabilityOtpMobileLine({ payload }) {
  if (!sendPortabilityOtpModule) {
    sendPortabilityOtpModule = yield call(() =>
      import('./send-portability-otp')
    );
  }
  yield call(sendPortabilityOtpModule.sendPortabilityOtpMobileLine, {
    payload,
  });
}
let validatePortabilityOtpModule = null;
export function* validatePortabilityOtpMobileLine({ payload }) {
  if (!validatePortabilityOtpModule) {
    validatePortabilityOtpModule = yield call(() =>
      import('./validate-portability-otp')
    );
  }
  yield call(validatePortabilityOtpModule.validatePortabilityOtpMobileLine, {
    payload,
  });
}
let validateAllOtpsModule = null;
export function* validateAllOtpsMobileLine({ payload }) {
  if (!validateAllOtpsModule) {
    validateAllOtpsModule = yield call(() => import('./validate-all-otps'));
  }
  yield call(validateAllOtpsModule.validateAllOtpsMobileLine, {
    payload,
  });
}
